import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';
import ErrorHandle from '../../../../common/utils/ErrorHandle';

export default {
	updateProfile({
        commit,
        state
    }, data) {
        const email = state.personalInfo.email;
        commit('SET_PAGE', {
            loading: true
        });
        commit('SET_PERSONAL_INFO', {
            error: '',
            loading: true
        });
        axios.post(process.env.MIX_API_URL + 'update-profile', {
                ...data
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data.hasOwnProperty('outcome') && data.outcome.error == 'true') {
                    commit('SET_PERSONAL_INFO', {
                        error: data.outcome.message,
                        loading: false
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                } else {
                    //alert('Your profile has been updated successfully.');
                    $('.profile-toast').toast({
                        delay: 3000
                    });
                    $('.profile-toast').toast('show');
                    commit('SET_PERSONAL_INFO', {
                        loading: false
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                    this.dispatch('getUser', email);
                }
            })
            .catch(e => {
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                        'request_uri': 'update-profile'
                    });
                }

                commit('SET_PERSONAL_INFO', {
                    error,
                    loading: false
                });
                commit('SET_PAGE', {
                    loading: false
                });
            });
    },
    updatePassword({
        commit,
        state
    }, data) {
        const email = state.personalInfo.email;
        commit('SET_PAGE', {
            loading: true
        });
        commit('SET_UPDATE_PASSWORD', {
            error: '',
            success: false,
            loading: true
        });
        axios.post(process.env.MIX_API_URL + 'update-password', {
                ...data,
                email
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data.hasOwnProperty('outcome') && data.outcome.error == 'true') {
                    commit('SET_UPDATE_PASSWORD', {
                        error: data.outcome.message,
                        loading: false
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                } else {
                    //alert('Your password has been changed successfully.');
                    commit('SET_UPDATE_PASSWORD', {
                        loading: false,
                        success: true
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                    setTimeout(() => {
                        commit('SET_UPDATE_PASSWORD', {
                            success: false
                        });
                    }, 1000);
                }
            })
            .catch(e => {
                commit('SET_UPDATE_PASSWORD', {
                    error: helper.errorCatch(e),
                    loading: false
                });
                commit('SET_PAGE', {
                    loading: false
                });
            });
    },
}